import Text from '../Text';
import { ERROR_404 } from '../../constants/localizations/app';
import ErrorPage from './ErrorPage';

const Error404 = () => (
  <ErrorPage httpStatusCode={404} message={<Text name={ERROR_404} />} />
);

export default Error404;
